// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39ydy","badges":"styles_badges__1veN3"};